import { useTranslation } from 'react-i18next'
import type { CalculateResponse } from '@itsrever/returns-api-types'
import { useAppSelector } from '@/redux/hooks'
import { LineItemLabel } from './line-item-label'
import { useTranslate } from '@/hooks'

interface CheckoutPaymentBalanceProps {
  summary: CalculateResponse
}

export const CheckoutPaymentBalance = ({
  summary
}: CheckoutPaymentBalanceProps) => {
  const { i18n } = useTranslation()
  const { translate } = useTranslate()

  const orderMoneyFormat =
    useAppSelector(
      (store) => store.returnsApi.order.response?.order?.money_format
    ) ?? {}

  const totalPaymentAmount =
    summary?.signed_summary?.return_summary?.total_payment_amount ?? 0

  return (
    <div className="space-y-3 pt-5">
      <h3
        className="text-xs font-normal uppercase tracking-wide text-neutral-500"
        dangerouslySetInnerHTML={{
          __html: translate('confirmation_page_you_pay_title')
        }}
      />
      <dl className="space-y-1">
        {summary?.signed_summary?.return_summary?.line_items?.map((item) => {
          if (item.checkout_payment_item) {
            return (
              <div className="flex justify-between gap-2" key={item.subtype}>
                <LineItemLabel subtype={item.subtype ?? ''} name={item.name} />
                <dd className="text-sm font-normal text-neutral-800">
                  {(
                    (item.total ?? 0) /
                    (orderMoneyFormat.amount_multiplied_by ?? 100)
                  ).toLocaleString(i18n.language, {
                    style: 'currency',
                    currency: orderMoneyFormat.currency
                  })}
                </dd>
              </div>
            )
          }

          return null
        })}
        <div className="flex justify-between gap-2 pt-0.5">
          <dt
            className="text-sm font-medium text-neutral-800"
            dangerouslySetInnerHTML={{
              __html: translate('confirmation_page_total_to_pay_title')
            }}
          />
          <dd className="text-base font-medium text-neutral-800">
            {(
              totalPaymentAmount /
              (orderMoneyFormat.amount_multiplied_by ?? 100)
            ).toLocaleString(i18n.language, {
              style: 'currency',
              currency: orderMoneyFormat.currency
            })}
          </dd>
        </div>
      </dl>
    </div>
  )
}
